import React from "react";
import { Select } from "antd";
import { FilterField } from "./FilterShared";
import { LANGUAGE_OPTIONS } from "./filterOptions";

const BASE_SELECT = { style: { width: "100%" }, allowClear: true };

const LanguagePanel = ({ values, set }) => (
  <div className="qp-filter-panel-body">
    <FilterField label="Language">
      <Select
        {...BASE_SELECT}
        mode="multiple"
        showSearch
        placeholder="e.g. English, Spanish"
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        value={values.language}
        onChange={set("language")}
        options={LANGUAGE_OPTIONS.map((o) => ({ label: o.title, value: o.value }))}
      />
    </FilterField>
  </div>
);

export default LanguagePanel;
